import React from 'react';
import { getClass } from '../../_lib/helper';
import './NativeTableHeader.scss';
function NativeTableHeader(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("thead", { className: getClass('elmo-nativetable-head', className) }, children));
}
export default NativeTableHeader;
